module.exports = __webpack_public_path__ + "static/media/banner.3af5e377.png";